// utils/cookieManager.js
import Cookies from 'js-cookie';

export const CURRENT_USER_TYPE = 'org_userType';
export const VISIBLE_STRENGTH = 'org_visibleStrength';
export const VISIBLE_WEAKNESSES = 'org_visibleWeakness';
export const VISIBLE_VALUES = 'org_visiblePersonalValues';
export const VISIBLE_MOTIVATES_YOU = 'org_visibleMotiavate';
export const VISIBLE_DISC = 'org_visibleStrength';
export const VISIBLE_GOALS = 'org_visibleGoals';
export const SESSION_ACTIVE = 'org_session_active';
export const ORG_ACCESS_TOKEN = 'org_access_token';

const COOKIE_PATH = '/';

const LEGACY_COOKIE_PATHS = ['/organization'];

const cookieOptions = {
  expires: 30,
  secure: import.meta.env.PROD,
  sameSite: 'strict',
  path: COOKIE_PATH,
};

export function getItem(key) {
  return Cookies.get(key);
}

export function setItem(key, value) {
  return Cookies.set(key, value, cookieOptions);
}

export function removeItem(key) {
  Cookies.remove(key, { path: COOKIE_PATH });
  Cookies.remove(key, { path: '/' });
  LEGACY_COOKIE_PATHS.forEach((legacyPath) => {
    Cookies.remove(key, { path: legacyPath });
  });
}

export const isUserAuthenticated = () => {
  const sessionFlag = getItem(SESSION_ACTIVE);
  if (sessionFlag === 'true') {
    return true;
  }
  return !!getItem(CURRENT_USER_TYPE);
};

export const getCurrentUser = () => {
  return getItem(CURRENT_USER_TYPE);
};

export const setUser = (user) => {
  setItem(CURRENT_USER_TYPE, user);
};
export function clearAllCookies() {
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    const cookieName = name.trim();
    document.cookie =
      cookieName + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;';
    document.cookie =
      cookieName +
      `=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${COOKIE_PATH};`;
    LEGACY_COOKIE_PATHS.forEach((legacyPath) => {
      document.cookie =
        cookieName +
        `=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${legacyPath};`;
    });
  }
}
export const logoutUser = () => {
  clearAllCookies();
  removeItem(SESSION_ACTIVE);
  removeItem(ORG_ACCESS_TOKEN);
};

export const markSessionActive = () => {
  setItem(SESSION_ACTIVE, 'true');
};
